import { render, staticRenderFns } from "./Guest-list.vue?vue&type=template&id=229fd538&"
import script from "./Guest-list.vue?vue&type=script&lang=js&"
export * from "./Guest-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports